

import { Box, Container } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import { useTheme } from '@mui/material/styles';
import MDTypography from "components/MDTypography";
import { keyframes } from '@mui/system';

// Define keyframes using MUI's keyframes helper
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const loading = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const UnauthorizedAccess = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          animation: `${fadeIn} 0.5s ease-in`
        }}
      >
        <BlockIcon 
          sx={{ 
            fontSize: 100, 
            color: theme.palette.info.main,
            animation: `${pulse} 2s infinite`,
            mb: 3
          }} 
        />
        <MDTypography
          variant="h3"
          sx={{
            color: theme.palette.info.main,
            mb: 2
          }}
        >
          Access Denied
        </MDTypography>
        <MDTypography
          variant="body1"
          sx={{
            mb: 3,
            color: 'text.secondary'
          }}
        >
          You don't have permission to access this record.
          Redirecting to list page...
        </MDTypography>
        <Box
          sx={{
            width: 200,
            height: 4,
            backgroundColor: 'background.paper',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundColor: theme.palette.info.main,
              animation: `${loading} 2s linear infinite`,
            }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default UnauthorizedAccess;